import {backUrl} from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";
import Cookies from "js-cookie";

export const getMonthlyPayments = async (requesterId, token) => {
  const csrfToken = Cookies.get("csrfToken");
  const req = await apiFetch(`${backUrl}/recurringPayments/getPayments/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken
    },
    body: JSON.stringify({
      requesterId
    })
  });
  const res = await req.json();
  return res;
};

export const getInvestments = async (requesterId, token) => {
  const req = await apiFetch(`${backUrl}/integratedInvestments/getAll`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId
    })
  });
  const res = await req.json();
  return res;
};

export const getRecurringPayment = async (
  requesterId,
  token,
  recurringPaymentId
) => {
  const req = await apiFetch(`${backUrl}/recurringPayments/getById`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      recurringPaymentId
    })
  });
  const res = await req.json();
  return res;
};

export const getInvestment = async (requesterId, token, investmentId) => {
  const req = await apiFetch(`${backUrl}/integratedInvestments/getById`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      investmentId
    })
  });
  const res = await req.json();
  return res;
};

export const updateRecurringPayment = async (
  requesterId,
  token,
  recurringPaymentId,
  updatedPayment
) => {
  const req = await apiFetch(`${backUrl}/recurringPayments/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      recurringPaymentId,
      updatedPayment
    })
  });
  const res = await req.json();
  return res;
};

export const updateInvestment = async (
  requesterId,
  token,
  investmentId,
  updatedInfo
) => {
  const req = await apiFetch(`${backUrl}/integratedInvestments/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      investmentId,
      updatedInfo
    })
  });
  const res = await req.json();
  return res;
};

export const createNewPayment = async (requesterId, token, newPayment) => {
  const req = await apiFetch(`${backUrl}/payments/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      newPayment
    })
  });
  const res = await req.json();
  return res;
};

export const updatePayment = async (
  requesterId,
  token,
  paymentId,
  paymentToUpdate
) => {
  const req = await apiFetch(`${backUrl}/payments/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      paymentId,
      paymentToUpdate
    })
  });
  const res = await req.json();
  return res;
};

export const getTpagaBalance = async (requesterId, token) => {
  const req = await apiFetch(`${backUrl}/tpaga/getMantisBalance`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const getTpagaProviders = async (token) => {
  const req = await apiFetch(`${backUrl}/tpaga/getServiceProviders`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  const res = await req.json();
  return res;
};

export const queryTpagaBill = async (
  serviceProviderId,
  billReference,
  token
) => {
  const req = await apiFetch(`${backUrl}/tpaga/queryBill`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({serviceProviderId, billReference})
  });
  const res = await req.json();
  return res;
};

export const payTpagaBill = async (
  idempotencyToken,
  amount,
  utilityProvider,
  shortBillReference,
  paymentToken,
  paymentOrigin,
  token
) => {
  const req = await apiFetch(`${backUrl}/tpaga/payBill`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      idempotencyToken,
      amount,
      utilityProvider,
      shortBillReference,
      paymentToken,
      paymentOrigin
    })
  });
  const res = await req.json();
  return res;
};

export const getMantisParams = async (token) => {
  const req = await apiFetch(`${backUrl}/mantisParams/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  const res = await req.json();
  return res;
};

export const updateMantisParams = async (token, requesterId, updatedParams) => {
  const req = await apiFetch(`${backUrl}/mantisParams/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, updatedParams})
  });
  const res = await req.json();
  return res;
};

export const getIrisLinkRequests = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/collectionSources/getIrisLinkRequests`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const setIrisLink = async (
  token,
  requesterId,
  collectionSourceId,
  irisLink,
  amount,
  name,
  cellPhone
) => {
  const req = await apiFetch(`${backUrl}/collectionSources/setIrisLink`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      collectionSourceId,
      irisLink,
      amount,
      name,
      cellPhone
    })
  });
  const res = await req.json();
  return res;
};

export const getMoneyOnMandateComponents = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/moneyOnMandateComponents/getAll`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const approveMoneyOnMandateComponent = async (
  token,
  requesterId,
  moneyOnMandateComponentId
) => {
  const req = await apiFetch(`${backUrl}/moneyOnMandateComponents/approve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, moneyOnMandateComponentId})
  });
  const res = await req.json();
  return res;
};

export const declineMoneyOnMandateComponent = async (
  token,
  requesterId,
  moneyOnMandateComponentId,
  deniedReason
) => {
  const req = await apiFetch(`${backUrl}/moneyOnMandateComponents/decline`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      moneyOnMandateComponentId,
      deniedReason
    })
  });
  const res = await req.json();
  return res;
};

export const getDashboardData = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/insights/getDashboardData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const getBillingData = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/insights/getBillingData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const updateUser = async (token, userId, updatedFields, requesterId) => {
  const req = await apiFetch(`${backUrl}/users/adminUpdate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({userId, updatedFields, requesterId})
  });
  const res = await req.json();
  return res;
};

export const getUserDashboardData = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/insights/getUserDashboardData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const searchUser = async (token, requesterId, searchQuery) => {
  const req = await apiFetch(`${backUrl}/backoffice/searchUser`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, searchQuery})
  });
  const res = await req.json();
  return res;
};

export const getUserRecurringPayments = async (token, requesterId, userId) => {
  const req = await apiFetch(`${backUrl}/backoffice/getUserRecurringPayments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, userId})
  });
  const res = await req.json();
  return res;
};

export const getUserBalance = async (token, requesterId, userId) => {
  const req = await apiFetch(`${backUrl}/backoffice/getUserBalance`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, userId})
  });
  const res = await req.json();
  return res;
};

export const getMantisFee = async (
  token,
  requesterId,
  paymentsToPay,
  userId
) => {
  const req = await apiFetch(`${backUrl}/backoffice/getMantisFee`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, paymentsToPay, userId})
  });
  const res = await req.json();
  return res;
};

export const createMoneyOnMandate = async (
  token,
  requesterId,
  userId,
  amountPaidByUser,
  recurringPaymentIds,
  paymentsAmount,
  mantisFee
) => {
  const req = await apiFetch(`${backUrl}/backoffice/createMoneyOnMandate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      userId,
      amountPaidByUser,
      recurringPaymentIds,
      paymentsAmount,
      mantisFee
    })
  });
  const res = await req.json();
  return res;
};

export const getUserBalances = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/backoffice/getUserBalances`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const getUserBalanceComponents = async (token, requesterId, userId) => {
  const req = await apiFetch(`${backUrl}/getUserBalanceComponents`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, userId})
  });
  const res = await req.json();
  return res;
};

export const generateBalanceComponent = async (
  token,
  requesterId,
  userId,
  amount,
  type,
  description,
  sign
) => {
  const req = await apiFetch(`${backUrl}/generateBalanceComponent`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      userId,
      amount,
      type,
      description,
      sign
    })
  });
  const res = await req.json();
  return res;
};

export const updateBalanceComponent = async (
  token,
  requesterId,
  balanceComponentId,
  updatedBalanceComponent,
  userId
) => {
  const req = await apiFetch(`${backUrl}/updateBalanceComponent`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      requesterId,
      balanceComponentId,
      updatedBalanceComponent,
      userId
    })
  });
  const res = await req.json();
  return res;
};

export const getStartcoConversations = async (token, requesterId) => {
  const req = await apiFetch(`${backUrl}/backoffice/startco/getConversations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const switchStartcoConversationMode = async (
  token,
  requesterId,
  conversationId
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/startco/switchConversationMode`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({requesterId, conversationId})
    }
  );
  const res = await req.json();
  return res;
};

export const sendStartcoManualMessage = async (
  token,
  requesterId,
  conversationId,
  message
) => {
  const req = await apiFetch(`${backUrl}/backoffice/startco/sendManualMessage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, conversationId, message})
  });
  const res = await req.json();
  return res;
};

export const getStartcoConversation = async (
  token,
  requesterId,
  conversationId
) => {
  const req = await apiFetch(`${backUrl}/backoffice/startco/getConversation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, conversationId})
  });
  const res = await req.json();
  return res;
};

export const getMantisBusinesses = async (token, requesterId) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/getBusinesses`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({requesterId})
    }
  );
  const res = await req.json();
  return res;
};

export const getMantisBusiness = async (
  token,
  requesterId,
  mantisBusinessId
) => {
  const req = await apiFetch(`${backUrl}/backoffice/mantisBusiness/getBusiness`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId, mantisBusinessId})
  });
  const res = await req.json();
  return res;
};

export const getAllPermissions = async (requesterId, token) => {
  const req = await apiFetch(`${backUrl}/backoffice/getAllPermissions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({requesterId})
  });
  const res = await req.json();
  return res;
};

export const updateBusinessPermissions = async (
  requesterId,
  mantisBusinessId,
  permissions,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/updatePermissions`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId,
        permissions
      })
    }
  );
  const res = await req.json();
  return res;
};

export const updateBusinessEnabledSections = async (
  requesterId,
  mantisBusinessId,
  sections,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/updateEnabledSections`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId,
        sections
      })
    }
  );
  const res = await req.json();
  return res;
};

export const updateBusinessDahboardUrls = async (
  requesterId,
  mantisBusinessId,
  urlObjects,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/updateDashboardUrls`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId,
        urls: urlObjects
      })
    }
  );
  const res = await req.json();
  return res;
};

export const createMantisBusiness = async (
  requesterId,
  business,
  mainUserPassword,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/createBusiness`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        business,
        mainUserPassword
      })
    }
  );
  const res = await req.json();
  return res;
};

export const updateMantisBusiness = async (
  requesterId,
  mantisBusinessId,
  updatedBusiness,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/updateBusiness`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId,
        updatedBusiness
      })
    }
  );
  const res = await req.json();
  return res;
};

export const updateMainUserPassword = async (
  requesterId,
  mantisBusinessId,
  password,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/mainUserPassword`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId,
        password
      })
    }
  );
  const res = await req.json();
  return res;
};

export const getMantisBusinessDocumentQueries = async (
  requesterId,
  mantisBusinessId,
  token
) => {
  const req = await apiFetch(
    `${backUrl}/backoffice/mantisBusiness/getMantisBusinessDocumentQueries`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId
      })
    }
  );
  const res = await req.json();
  return res;
};
